module.exports = __webpack_public_path__ + "static/media/Attendance.c1b0a952.jpg";